<template>
  <div id="app">
    <keep-alive>
      <router-view />
    </keep-alive>
    <div class="global-loader v cc" :class="{show: loading}">
      <div class="inner">
        <div class="spinner big"></div>
      </div>
    </div>

    <div class="global-message v cc" :class="{show: message.open}">
      <div class="inner v cc">
        <i :class="message.options && message.options.type"></i>
        <div class="padding-08-10 ta-c" v-html="message.options && message.options.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config";

export default {
  name: "App",
  data() {
    return {
      loading: false,
      message: {
        timer: null,
        open: false,
        options: null
      }
    };
  },
  methods: {
    showLoading() {
      this.loading = true;
    },
    hideLoading() {
      this.loading = false;
    },
    sendMessage(type, message) {
      if (this.message.timer) clearTimeout(this.message.timer);
      if (this.$isPlainObject(type)) {
        this.message.options = type;
      } else {
        this.message.options = {
          type: type,
          content: message
        };
      }
      this.message.open = true;
      this.message.timer = setTimeout(_ => {
        this.message.open = false;
      }, 3000);
    },
    disconnect() {},
    registerWechatSdk() {
      this.$ScriptLinker("//res.wx.qq.com/open/js/jweixin-1.3.2.js").then(_ => {
        let url = config.hosts.resource + "?";
        this.$http
          .get(`jssdk/wxconfig?url=${encodeURIComponent(url)}`)
          .then(res => {
            if (res.success && res.content) {
              let options = Object.assign(res.content, {
                debug: false,
                jsApiList: [
                  "getLocation",
                  "scanQRCode",
                  "closeWindow",
                  "onMenuShareTimeline",
                  "onMenuShareAppMessage",
                  "onMenuShareQQ",
                  "onMenuShareWeibo",
                  "onMenuShareQZone",
                  "hideMenuItems",
                  "chooseImage",
                  "uploadImage",
                  "getLocalImgData",
                  "showAllNonBaseMenuItem",
                  "configWXDeviceWiFi"
                ]
              });
              window.wx.config(options);
            }
          });
      });
    }
  },
  mounted() {
    document.body.addEventListener("touchstart", function() {});
    window.addEventListener("contextmenu", function(e) {
      e.preventDefault();
    });
    window.sendMessage = this.sendMessage;
    this.registerWechatSdk();
  }
};
</script>

<style lang="less">
body {
  padding: 0;
  margin: 0;
}
#app {
  height: 100%;
  overflow: hidden;
}

.global-loader,
.global-message {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background-color: rgba(255, 255, 255, 0.25);
  opacity: 0;
  pointer-events: none;
  transition: all 0.5s;

  > .inner {
    //background-color: white;
    padding: 1rem;
    //box-shadow: 0 0 3rem rgba(0, 0, 0, 0.3);
  }

  &.show {
    opacity: 1;
    pointer-events: auto;
  }
}

.global-message {
  background-color: rgba(0, 0, 0, 0.2);
  > .inner {
    max-width: 80%;
    border-radius: 0.5rem;
    background-color: white;
    box-shadow: 0 0 2rem rgba(0, 0, 0, 0.2);
    transition: all 0.5s;
    transform: translateY(200%);
  }

  &.show > .inner {
    transform: translateY(0);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue